import { makeStyles } from 'tss-react/mui';

const useStylesFieldAddressBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  fieldAddressBlock: {
    '& > div': {
      minWidth: 0,
      '&:nth-of-type(1)': {
        width: '50%',
      },
      '&:nth-of-type(2)': {
        width: 'calc(35% - 5px)',
        marginLeft: 5,
      },
      '&:nth-of-type(3)': {
        width: 'calc(15% - 5px)',
        marginLeft: 5,
      },
    },
  },
  fieldAddressBlockDefault: {
    '& > div': {
      '&:nth-of-type(1)': {
        [theme.breakpoints.down('md')]: {
          width: '100%',
        },
      },
      '&:nth-of-type(2)': {
        [theme.breakpoints.down('md')]: {
          marginTop: 5,
          marginLeft: 0,
          width: 'calc(70% - 5px)',
        },
      },
      '&:nth-of-type(3)': {
        [theme.breakpoints.down('md')]: {
          float: 'right',
          width: '30%',
          marginLeft: 0,
          marginTop: 5,
        },
      },
    },
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  fieldAddressBlockCompressed: {
    '& > div': {
      '&:nth-of-type(1)': {
        [theme.breakpoints.down('lg')]: {
          width: '100%',
        },
      },
      '&:nth-of-type(2)': {
        [theme.breakpoints.down('lg')]: {
          marginTop: 5,
          marginLeft: 0,
          width: 'calc(70% - 5px)',
        },
      },
      '&:nth-of-type(3)': {
        [theme.breakpoints.down('lg')]: {
          float: 'right',
          width: '30%',
          marginLeft: 0,
          marginTop: 5,
        },
      },
    },
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  },
  fieldAddressBlockOffset: {
    '& > div:nth-of-type(2)': {
      [theme.breakpoints.down('sm')]: {
        width: 'calc(70% - 15px)',
      },
    },
  },
  fieldAddressBlockOffsetCompressed: {
    '& > div:nth-of-type(2)': {
      [theme.breakpoints.down('lg')]: {
        width: 'calc(70% - 15px)',
      },
    },
  },
  fieldAddressBlockInline: {
    minWidth: 400,
    '& > div': {
      '&:nth-of-type(1)': {
        width: 'calc(50% + 40px)',
      },
      '&:nth-of-type(2)': {
        width: 'calc(25% - 5px)',
        marginLeft: 5,
      },
      '&:nth-of-type(3)': {
        width: 'calc(15% - 5px)',
        marginLeft: 5,
      },
    },
  },
}));

export default useStylesFieldAddressBlock;
